<template>
  <div class="page-bg">
    <!-- <div style="height:64px;display:flex;justify-content: center;">
      <el-row class="title-box">
        <el-col class="four-color-box">
          <div
            v-for="(item, index) in fourColorList"
            :key="index"
            class="four-color-item"
          >
            <div :style="'border-radius: 4px;background-color:' + item.color"></div>
            <span style="font-size: 16px;">{{ item.name }}</span>
          </div>
        </el-col>
        <el-col
          ><span class="title-content-box">校园安全风险防控平台</span></el-col
        >
        <el-col class="time-box">
          <the-now-time></the-now-time>
        </el-col>
      </el-row>
    </div> -->
    <el-row class="content-box">
      <el-col :span="7" style="height:100%">
        <div class="content-left-top-box">
          <div
            v-for="(item, index) in leftNumberList"
            :key="index"
            class="num-bg"
          >
            <img :src="item.icon" alt="" />
            <div>{{ schoolInfo[index] }}{{ item.unit }}</div>
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="content-left-centre-box">
            <dv-border-box-10 class="chart-box">

            <div class="chart-title">
              发现隐患分类占比
            </div>
            <div class="chart-title-line" style="width:27%"></div>
            <unsafe-type-echarts
              style="height:calc(100% - 50px);width:100%"
              :echartsData="dangerTypes"
              v-if="dangerTypes.length > 0"
            ></unsafe-type-echarts>
            <div v-else class="chart-no-data">暂无数据</div>
            </dv-border-box-10>
        </div>
        <div class="content-left-bottom-box">
          <div class="chart-info">
            <dv-border-box-10 class="chart-box">
              <div class="chart-title">
                隐患实时动态
              </div>
              <div class="chart-title-line" style="width:20%"></div>
              <hidden-danger-now
                style="margin-top:10px;
        scrollbar-width: none;"
                :hiddenTroubleList="hiddenTroubleList"
              ></hidden-danger-now>
            </dv-border-box-10>
          </div>
          <hidden-danger-now-dialog></hidden-danger-now-dialog>
        </div>
      </el-col>
      <el-col :span="10" style="height:100%">
        <div class="content-centre-top-box">
          <!-- <div class="num-bg">
            <div v-for="(item, index) in 6" :key="index" class="num-item">
              <span>
                {{ totalNum.toString().padStart(6, "0")[index] }}
              </span>
            </div>
          </div>
          <div class="num-title">
            <span>区域内隐患总数</span>
          </div> -->
          <dv-decoration-7 class="school-box">
            <span>{{ schoolBasicsInfo.schoolName || "***" }} </span>
          </dv-decoration-7>
        </div>
        <div class="content-centre-centre-box">
          <img
            v-if="schoolImg"
            :src="$store.state.config.fileUrl + schoolImg"
            alt=""
          />
          <div v-else style="font-size:20px" class="chart-no-data">
            暂无图片
          </div>
        </div>
        <div class="content-centre-bottom-box">
          <dv-border-box-10 class="chart-box">
            <div class="chart-title-box">
              <div
                style="width:30%;display: flex;justify-content: center;flex-direction: column;align-items:center"
              >
                <div class="chart-title-left">
                  巡查点总数({{ spectionareasNum }})
                </div>
                <div class="chart-title-line-left"></div>
              </div>
              <div
                style="width:40%;display: flex;justify-content: center;flex-direction: column;align-items:center"
              >
                <div class="chart-title-two">
                  巡岗巡查统计波段图
                </div>
                <div class="chart-title-line-two" style="width:60%"></div>
              </div>
              <div
                style="width:30%;display: flex;justify-content: center;flex-direction: column;align-items:center"
              >
                <div class="chart-title-right">
                  巡查点上报隐患({{ spectionareasHeNum }})
                </div>
                <div class="chart-title-line-right"></div>
              </div>
            </div>
            <stacked-line-chart
              style="height:75%;width:100%"
              :echartsData="patrolStatistics"
              v-if="patrolStatistics.length > 0"
            >
            </stacked-line-chart>
            <div v-else class="chart-no-data">
              暂无数据
            </div>
          </dv-border-box-10>
        </div>
      </el-col>
      <el-col :span="7" style="height:100%">
        <div class="content-right-top-box">
          <div
            v-for="(item, index) in drillNumberList"
            :key="index"
            class="num-bg"
          >
            <div style="margin-top:24px">
              {{ schoolSafeInfo[index] }}{{ item.unit }}
            </div>
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="content-right-centre-box">
          <dv-border-box-10 class="chart-box">
            <div class="chart-title">
              教师安全评分
            </div>
            <div class="chart-title-line" style="width:23%;
        scrollbar-width: none;"></div>
            <rate-list-chart
              style="width:100%;height:calc(100% - 50px)"
              :echartsData="recordInfo"
              v-if="recordInfo"
            ></rate-list-chart>
            <div v-else class="chart-no-data">
              暂无数据
            </div>
          </dv-border-box-10>
        </div>
        <div class="content-right-bottom-box">
          <dv-border-box-10 class="chart-box">
            <div class="chart-title">
              教师安全评分排行
            </div>
            <div class="chart-title-line" style="width:32%"></div>
            <div class="list-title">
              <div class="item-left">
                排名
              </div>
              <div class="item-center">
                用户名
              </div>
              <div class="item-right">
                总积分
              </div>
            </div>
            <div class="school-grade-list" v-if="teacherRankList.length > 0">
              <div
                class="list-item"
                v-for="(item, index) in teacherRankList"
                :key="index"
              >
                <div class="item-left">NO.{{ index + 1 }}</div>
                <div class="item-center">
                  {{ item.userName || "---" }}
                </div>
                <div class="item-right">
                  {{ item.totalNum }}
                </div>
              </div>
            </div>
            <div v-else class="table-no-data">
              暂无数据
            </div>
          </dv-border-box-10>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import theNowTime from "./components/theNowTime";
import rateListChart from "./components/rateListChart";
import hiddenDangerNow from "./components/hiddenDangerNow";
import hiddenDangerNowDialog from "./components/hiddenDangerNowDialog";
import stackedLineChart from "./components/stackedLineChart";
import unsafeTypeEcharts from "./components/unsafeTypeEcharts";
export default {
  name: "safepostureSchool",
  components: {
    theNowTime,
    rateListChart,
    hiddenDangerNow,
    hiddenDangerNowDialog,
    stackedLineChart,
    unsafeTypeEcharts
  },
  data() {
    return {
      fourColorList: [
        { name: "重大风险", color: "#FF0000" },
        { name: "较大风险", color: "#FF6100" },
        { name: "一般风险", color: "#FFFF00" },
        { name: "低风险", color: "#0000FF" }
      ],
      leftNumberList: [
        {
          icon: require("@/assets/img/safepostureSchool/monitoring-icon.png"),
          title: "监控区域",
          unit: "处"
        },
        {
          icon: require("@/assets/img/safepostureSchool/teacher-icon.png"),
          title: "教师总数",
          unit: "人"
        },
        {
          icon: require("@/assets/img/safepostureSchool/student-icon.png"),
          title: "学生总数",
          unit: "人"
        }
      ],
      drillNumberList: [
        {
          title: "演练次数",
          unit: "次"
        },
        {
          title: "接入视频总数",
          unit: "个"
        },
        {
          title: "接入广播总数",
          unit: "条"
        }
      ],
      totalNum: 0, //区域内隐患总数
      schoolImg: "", //学校图片
      schoolInfo: [], //学校信息
      schoolSafeInfo: [], //校内安全信息
      schoolGradeList: [],
      teacherRankList: [], //积分排行榜
      hiddenTroubleList: [], //隐患实时动态
      spectionareasNum: "", //巡查点总数
      spectionareasHeNum: "", //巡查点上报隐患
      recordInfo: {}, //教师安全评分
      patrolStatistics: [], //日常巡查统计波段图
      dangerTypes: [], //隐患分类占比
      infoObj: {}
    };
  },
  mounted() {
    this.getInfo();
  },
  computed: {
     schoolBasicsInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  methods: {
    async getInfo() {
      this.schoolInfo = [];
      this.schoolSafeInfo = [];
      let res = await this.$Http.getStatisticsInfo({
        schoolId: this.$store.state.schoolId
      });
      if (res.code == 200) {
        let data = res.data;
        this.totalNum = data.troubleNum || 0;
        this.schoolImg = data.basicDataPlane.graphicImagesUrl || "";
        this.schoolInfo.push(data.schoolInfo.monitorTotal || 0); //监控区域数量
        this.schoolInfo.push(data.schoolInfo.userNum || 0); //教师数量
        this.schoolInfo.push(data.schoolInfo.stuNum || 0); //学生数量
        this.schoolSafeInfo.push(data.schoolSafeInfo.drillPlanTotal || 0); //监控区域数量
        this.schoolSafeInfo.push(data.schoolSafeInfo.monitorTotal || 0); //教师数量
        this.schoolSafeInfo.push(data.schoolSafeInfo.voiceTotal || 0); //学生数量
        this.hiddenTroubleList = data.hiddenTroubleList || [];
        this.teacherRankList = data.integralRecordStatistics || [];
        this.spectionareasNum = data.spectionareasNum || "0";
        this.spectionareasHeNum = data.spectionareasHeNum || "0";
        this.recordInfo = data.recordInfo;
        this.patrolStatistics = data.patrolStatistics || [];
        this.dangerTypes = data.dangerTypes || [];
      } else if (res.code == 101) {
      } else {
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-bg {
  // height: 100%;
  width: 100%;
  // overflow: scroll;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
    //  background: url('~@/assets/img/bg.png');

  // background: url("~@/assets/img/safepostureSchool/safeposture-bg.gif");
  background-size: 100% 100%;
  .title-box {
    margin-top: 14px;
    background-image: linear-gradient(
      to right,
      rgba(63, 98, 163, 0),
      rgba(63, 98, 163, 1),
      rgba(63, 98, 163, 0)
    );
    height: 40px;
    width: 90%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .four-color-box {
      display: flex;
      flex-direction: row;
      .four-color-item {
        margin-left: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        div {
          width: 16px;
          height: 16px;
        }
        span {
          margin-left: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          min-width: 64px;
        }
      }
    }
    .title-content-box {
      display: flex;
      justify-content: center;
      font-size: 20px;
      min-width: 200px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #95a5ff;
      background: linear-gradient(360deg, #ffea5b 0%, #ffffec 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .time-box {
      display: flex;
      justify-content: flex-end;
      min-width: 211px;
    }
  }
  .content-box {
    padding-top: 50px;
    width: 100%;
    // height: calc(100% - 100px);
    .content-left-top-box {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 200px;
      margin-top: 20px;
      .num-bg {
        margin-left: 40px;
        width: calc((100%-120px) / 3);
        max-width: 90px;
        height: 100%;
        background: url("~@/assets/img/fileIcon/record-icon-two.png") center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
        div {
          margin-top: 4px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fffec2;
        }
      }
    }
    .content-left-centre-box {
      transition: width 1s;
      margin-left: 7%;
      width: 90%;
      height: 300px;
      perspective: 200;
      -webkit-perspective: 200;
      .chart-box {
        width: 100%;
        height: 100%;
        transition: all 1s;
        -webkit-transform-origin: left center;
        transform: rotateY(1deg);
        &:hover {
          transform: rotateY(0deg);
        }
        .chart-content {
          width: 100%;
          height: 75%;
        }
      }
    }
    .content-left-bottom-box {
      margin-top: 50px;
      margin-left: 7%;
      width: 100%;
      height: 230px;
      display: flex;
      justify-content: center;
      .chart-info {
        width: 100%;
        height: 100%;
        // display: flex;
        // justify-content: center;
        perspective: 200;
        -webkit-perspective: 200;
        .chart-box {
          width: 90%;
          height: 100%;
          transition: all 1s;
          -webkit-transform-origin: left center;
          transform: rotateY(1deg);
          &:hover {
            transform: rotateY(0deg);
          }
        }
      }
      .hidden-danger-now {
        margin-top: 12px;
        width: 100%;
        height: 210px;
        background: url("~@/assets/img/eduBigData/hidden-danger-now-bg.png") center center no-repeat;
        background-size: 100% 100%;
        text-align: center;
        .now-name {
          padding-top: 8px;
          text-align: center;
          position: relative;
          div {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #effaff;
            letter-spacing: 1px;
            background: linear-gradient(180deg, #ffffff 0%, #cdf2ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          img {
          }
        }
      }
    }
    .content-centre-top-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 20px;
      // height: 12%;
      .school-box {
        width: 100%;
        height: 50px;
        span {
          margin: 0px 20px;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #a6e4f9;
          line-height: 37px;
          text-shadow: 0px 2px 4px rgba(255, 161, 161, 0.45);
          background: linear-gradient(180deg, #ffffff 0%, #ffeb9d 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          bottom: 5px;
        }
      }
      .num-bg {
        width: 509px;
        height: 54px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .num-item {
          width: 68px;
          height: 54px;
          margin: 0px 8.5px;
          background: url("~@/assets/img/eduBigData/num-bg.png") center center;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            font-size: 32px;
            font-family: Impact;
            color: #c4f0ff;
            background: linear-gradient(180deg, #64a6d0 0%, #b5e2ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .num-title {
        margin-top: -5px;
        background: url("~@/assets/img/safepostureSchool/num-title.png") center center;
        width: 509px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .content-centre-centre-box {
      background: url("~@/assets/img/safepostureSchool/school-img-bg.png") center center
        no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 500px;
      margin-top: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 760px;
        height: 424px;
      }
    }
    .content-centre-bottom-box {
      margin-top: 10px;
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      .chart-box {
        width: 80%;
        height: 100%;
        // display: flex;
        // justify-content: center;
        .chart-title-box {
          display: flex;
          justify-content: center;
          .chart-title-two {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #f8ff90;
            height: 40px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
          }
          .chart-title-line-two {
            margin-top: 5px;
            height: 4px;
            width: 100%;
            background-color: rgba(140, 216, 255, 0.5);
            box-shadow: 0px 0px 4px 0px #8cd8ff;
            display: flex;
            justify-content: center;
          }
          .chart-title-left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            height: 40px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            color: #c9efff;
          }
          .chart-title-line-left {
            margin-top: 5px;
            height: 2px;
            width: 60%;
            background-image: linear-gradient(
              to right,
              rgba(122, 240, 255, 0),
              rgba(122, 240, 255, 1),
              rgba(122, 240, 255, 0)
            );
          }
          .chart-title-right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            height: 40px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            color: #c9efff;
          }
          .chart-title-line-right {
            margin-top: 5px;
            height: 2px;
            width: 60%;
            background-image: linear-gradient(
              to right,
              rgba(122, 240, 255, 0),
              rgba(122, 240, 255, 1),
              rgba(122, 240, 255, 0)
            );
          }
        }
      }
    }
    .content-right-top-box {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 180px;
      .num-bg {
        margin-left: 10px;
        width: calc((100%-120px) / 3);
        max-width: 120px;
        // height: 50%;
        background: url("~@/assets/img/safepostureSchool/drill-num-bg.png") center center
          no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        div {
          margin-top: 4px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fffec2;
        }
      }
    }
    .content-right-centre-box {
      transition: width 1s;
      margin-left: 3%;
      margin-top: 20px;
      width: 90%;
      height: 300px;
      perspective: 200;
      -webkit-perspective: 200;
      .chart-box {
        width: 100%;
        height: 100%;
        transition: all 1s;
        -webkit-transform-origin: right center;
        transform: rotateY(-1deg);
        &:hover {
          transform: rotateY(0deg);
        }
      }
    }
    .content-right-bottom-box {
      transition: width 1s;
      margin-top: 50px;
      margin-left: 3%;
      width: 90%;
      height: 230px;
      display: flex;
      justify-content: center;
      perspective: 200;
      -webkit-perspective: 200;
      .chart-box {
        width: 100%;
        height: 100%;
        transition: all 1s;
        -webkit-transform-origin: right center;
        transform: rotateY(-1deg);
        &:hover {
          transform: rotateY(0deg);
        }
      }
    }
    .list-title {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      height: 28px;
      .item-left {
        width: 20%;
        color: #dbe1ff;
        text-align: center;
        font-size: 16px;
        line-height: 28px;
      }
      .item-center {
        width: 40%;
        color: #dbe1ff;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .item-right {
        width: 40%;
        text-align: center;
        color: #dbe1ff;
        font-size: 16px;
        line-height: 28px;
      }
    }
    .school-grade-list {
      height: 50%;
      overflow-y: scroll;
      scrollbar-width: none;
      .list-item {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        height: 28px;
        background: rgba(17, 165, 215, 0.04);
        &:nth-child(2n) {
          background: rgba(17, 165, 215, 0.14);
        }
        .item-left {
          text-align: center;
          width: 20%;
          color: #dbe1ff;
          font-size: 16px;
          line-height: 28px;
        }
        .item-center {
          width: 40%;
          color: #dbe1ff;
          font-size: 16px;
          line-height: 28px;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .item-right {
          text-align: center;
          width: 40%;
          color: #dbe1ff;
          font-size: 16px;
          line-height: 28px;
        }
      }
    }
    .table-no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50%;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.chart-title {
  margin-left: 30px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #f8ff90;
  height: 40px;
  display: flex;
  align-items: flex-end;
}
.chart-title-line {
  margin-left: 30px;
  margin-top: 5px;
  height: 4px;
  background-color: rgba(140, 216, 255, 0.5);
  box-shadow: 0px 0px 4px 0px #8cd8ff;
}
.chart-no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 75%;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
}
</style>
